'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";

// src/components/video/Grid.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { Typography as Typography2 } from "@wbk/ui";

// src/components/video/Item.tsx
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { PlayIcon } from "@wbk/svg";
import { Button, ImageWithPlaceholder, Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var VideoItem = ({ card, className }) => {
  var _a, _b;
  const [show, setShow] = useState(false);
  const isYouTube = (_a = card.href) == null ? void 0 : _a.includes("youtube.com/embed");
  return /* @__PURE__ */ jsxs("div", { className: "space-y-S", children: [
    /* @__PURE__ */ jsx("div", { className: twMerge("rounded-S aspect-[16/9]", className), children: show ? /* @__PURE__ */ jsx("div", { className: "rounded-S aspect-[16/9]", children: isYouTube ? /* @__PURE__ */ jsx(
      "iframe",
      {
        src: `${card.href}&autoplay=1&playsinline=1&rel=0`,
        title: "YouTube video player",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerPolicy: "strict-origin-when-cross-origin",
        allowFullScreen: true,
        className: "rounded-S relative h-full w-full"
      }
    ) : /* @__PURE__ */ jsxs(
      "video",
      {
        autoPlay: true,
        playsInline: true,
        disablePictureInPicture: true,
        controls: true,
        className: "rounded-S relative h-full w-full cursor-pointer",
        children: [
          /* @__PURE__ */ jsx("source", { src: card.href }),
          /* @__PURE__ */ jsx("track", { kind: "captions" })
        ]
      }
    ) }) : /* @__PURE__ */ jsx(
      "div",
      {
        className: twMerge(
          "rounded-S group aspect-[16/9] h-full w-full overflow-hidden",
          className
        ),
        children: /* @__PURE__ */ jsxs(
          Button,
          {
            theme: "transparent",
            className: "relative h-full w-full p-0",
            onClick: () => setShow(true),
            children: [
              /* @__PURE__ */ jsx(
                ImageWithPlaceholder,
                {
                  src: (_b = card.image) == null ? void 0 : _b.url,
                  className: "h-full w-full object-cover",
                  alt: ""
                }
              ),
              /* @__PURE__ */ jsx("div", { className: "p-M bg-body-level-1 border-body-level-2 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border-8 opacity-80", children: /* @__PURE__ */ jsx(PlayIcon, { className: "text-body-level-3 h-14 w-14 group-hover:opacity-70" }) })
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-XXS", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "label-L", children: card.title }),
      /* @__PURE__ */ jsx(Typography, { color: "text-secondary", variant: "body-S", children: card.subtitle })
    ] })
  ] });
};
var Item_default = VideoItem;

// src/components/video/Grid.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var VideoGrid = ({ section }) => {
  const cards = section.contentCollection.items;
  const count = cards.length;
  if (!count) return null;
  return /* @__PURE__ */ jsxs2(
    DecoratedSection_default,
    {
      section,
      className: "container relative overflow-hidden",
      "data-testid": `section_video_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx2(Typography2, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx2(Typography2, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx2(
          "div",
          {
            className: twMerge2(
              "grid items-start gap-10",
              count === 3 ? "xl:grid-row-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3" : count === 1 ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"
            ),
            children: cards.map((card, i) => {
              const itemClass = twMerge2(
                count === 3 && i === 0 && "xl:row-span-4 xl:col-span-2",
                count === 3 && i > 0 && "xl:row-span-2 xl:col-start-3"
              );
              return /* @__PURE__ */ jsx2("div", { className: itemClass, children: /* @__PURE__ */ jsx2(Item_default, { card }) }, card.id);
            })
          }
        )
      ]
    }
  );
};
var Grid_default = VideoGrid;

export {
  Grid_default
};
//# sourceMappingURL=chunk-527HO367.mjs.map